import { WorkflowQuestionConfig } from '../workflowQuestionConfig';
import { WorkflowResponseState } from '../workflowResponseState';

export interface LocationQuestionConfig extends WorkflowQuestionConfig {}

export interface LocationResponseState extends WorkflowResponseState {
  value?: string;
  coordinates?: [number, number];
}
